module.exports = __webpack_public_path__ + "img/2026big10.15efec4a.png";